import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { PetitumRevisione } from '../../../models/petitum-revisione';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { FondoRischiEditRevisioneComponent } from './sezione-economica-fondo-rischi-edit-revisione.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [sezione-economica-mod-fondo-rischi-edit-revisione]',
  templateUrl: 'sezione-economica-mod-fondo-rischi-edit-revisione.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ModFondoRischiEditRevisioneComponent {
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  isFs: boolean = PropertiesSettings.ID_TENANTS_FS();
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();
  @ViewChild('formFondoRischiRevisione') formFondoRischiRevisione: FondoRischiEditRevisioneComponent;
  @Input() edit: boolean;

  inizializza(sezione: SezioneEconomica, petitumRevisione: PetitumRevisione, fascicolo: FascicoloFull, urlUpdate: string, urlSezioneControparti: string = '', idSezioneControparti: string = '', idSezioneClassificazioni: string = '') {
    openModal('modaleFondoRischiRevisioneEdit');
    this.formFondoRischiRevisione.inizializza(sezione, petitumRevisione, fascicolo, urlUpdate, urlSezioneControparti, idSezioneControparti);
  }

  createForm() {
    this.formFondoRischiRevisione.createForm();
  }

  manageModal(sezioneEconomica: SezioneEconomica) {
      closeModal('modaleFondoRischiRevisioneEdit');
      this.onReturn.emit(sezioneEconomica);
  }

  closeModal() {
    closeModal('modaleFondoRischiRevisioneEdit');
  }
}
